module.exports = __webpack_public_path__ + "img/01-TITLE.1833cc04.png";